import posthog from 'posthog-js'

export function usePosthog() {
  if (!posthog.isFeatureEnabled('__init__')) {
    posthog.init(process.env.VUE_APP_POSTHOG_PROJECT_API_KEY, {
      api_host: process.env.VUE_APP_POSTHOG_API_HOST,
      defaults: '2025-05-24',
      person_profiles: 'identified_only'
    })
  }

  return { posthog }
}
